import React from "react";

export default function DangerDismissModal({
  open,
  onClose,
  onSubmit,
  workerName,
  setWorkerName,
  dismissReason,
  setDismissReason,
  submitting,
  dangerText,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100000] flex items-center justify-center bg-black/45 p-4">
      <div className="w-full max-w-lg rounded-3xl border border-red-200 bg-white p-6 shadow-2xl dark:border-red-800 dark:bg-[#111827]">
        <div className="mb-4">
          <div className="text-xl font-bold text-gray-900 dark:text-white">
            위험 감지 해제
          </div>
          <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            현재 위험: {dangerText || "-"}
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="mb-2 block text-sm font-semibold text-gray-700 dark:text-gray-200">
              관제 근무자 이름
            </label>
            <input
              type="text"
              value={workerName}
              onChange={(e) => setWorkerName(e.target.value)}
              placeholder="이름 입력"
              className="w-full rounded-2xl border border-gray-300 px-4 py-3 outline-none focus:border-red-400 dark:border-gray-700 dark:bg-[#0F172A] dark:text-white"
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-gray-700 dark:text-gray-200">
              해제 사유
            </label>
            <textarea
              value={dismissReason}
              onChange={(e) => setDismissReason(e.target.value)}
              placeholder="예: 현장 확인 완료, 오작동 해제"
              rows={4}
              className="w-full rounded-2xl border border-gray-300 px-4 py-3 outline-none focus:border-red-400 dark:border-gray-700 dark:bg-[#0F172A] dark:text-white"
            />
          </div>
        </div>

        <div className="mt-6 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="rounded-2xl bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-700 dark:bg-white/10 dark:text-gray-200"
          >
            취소
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={submitting}
            className="rounded-2xl bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-60"
          >
            {submitting ? "처리 중..." : "위험 해제"}
          </button>
        </div>
      </div>
    </div>
  );
}